
<div class="row align-items-center bg-us py-2" *ngIf="negociacao?.valorContraProposta">
    <div class="col text-center color-cinza-da-mata">
        <div class="label"> Valor solicitado </div>
        <div> {{negociacao?.valorContraProposta | currency: 'BRL'}} </div>
    </div>
    <div class="col-auto">
        <img class="rotate" src="/assets/imgs/icones/top-verde.svg" alt="">
    </div>
    <div class="col text-center text-success">
        <div class="label"> Contraproposta PJUS </div>
        <div class="text-bold"> {{negociacao?.valorOferta | currency: 'BRL'}} </div>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <div class="mt-3" *ngIf="negociacao?.dataPropostaPjus">
            <div class="label color-cinza-da-mata"> Data da solicitação </div>
            <div class="text-bold"> {{negociacao?.dataPropostaPjus | date: 'dd/MM/yyyy'}} </div>
        </div>
        <div class="mt-3" *ngIf="negociacao?.valorOfertaAnterior">
            <div class="label color-cinza-da-mata"> Valor propostado anteriormente </div>
            <div class="text-bold"> {{negociacao?.valorOfertaAnterior | currency: 'BRL'}} </div>
        </div>
        <div class="mt-3">
            <div class="label color-cinza-da-mata"> Retorno PJUS </div>
            <div class="text-bold"> {{negociacao?.observacaoPjus}} </div>
        </div>
    </div>
</div>